import { useEffect, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { fareharborUrl, FAREHARBOR_LINK_PROPS } from "@/utils/fareharbor";

export default function MobileStickyCTA() {
  const { lang, t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const fromLabel = lang === "es" ? "Desde" : "From";
  const bookLabel = t?.nav?.book || (lang === "es" ? "Reservar" : "Book Now");

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`fixed inset-x-0 bottom-0 z-30 transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!visible}
    >
      <div className="mx-3 mb-3 flex items-center justify-between gap-3 rounded-full border border-[#0A0A0A]/10 bg-white/95 px-3 py-2 shadow-2xl shadow-black/15 backdrop-blur-xl">
        <div className="flex items-center gap-3 pl-2">
          <div
            className="text-xs uppercase tracking-wider text-[#4A4A4A]"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            {fromLabel}
          </div>
          <div
            className="text-xl font-semibold tracking-tight text-[#0A0A0A]"
            style={{ fontFamily: "Fraunces, serif" }}
          >
            $40
          </div>
        </div>
        <a
          href={fareharborUrl("general", {
            utm_medium: "mobile-sticky",
            utm_campaign: "mobile-sticky",
          })}
          {...FAREHARBOR_LINK_PROPS}
          data-testid="mobile-sticky-book"
          className="inline-flex items-center gap-2 rounded-full bg-[#FF5533] px-5 py-3 text-sm font-semibold text-white shadow-md shadow-[#FF5533]/30 transition-all active:scale-95"
        >
          {bookLabel} →
        </a>
      </div>
    </div>
  );
}
